export enum InfoType {
  privacyPolicy = 'privacyPolicy',
  userAgreement = 'userAgreement',
}

export interface InfoResponse {
  text: string
}
